import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import NavBar from './components/NavBar.vue'
import BrandList from './components/BrandList.vue'
import PageFooter from './components/PageFooter.vue'

import './plugins/element.js'

import './assets/css/global.css'

// swiper组件
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style
import 'swiper/css/swiper.css'

// 预览图
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

Vue.use(VueAwesomeSwiper /* { default options with global component } */)
Vue.use(preview)
Vue.component('navbar', NavBar)
Vue.component('brand-list', BrandList)
Vue.component('page-footer', PageFooter)

Vue.prototype.$http = axios

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  store.commit('getMarketInfo')
  window.scrollTo(0, 0)
  next()
})

Vue.filter('getDate', function(value) {
  // 返回处理后的值
  var date = new Date(value * 1000)
  var Y = date.getFullYear() + '-'
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  var h = (date.getHours() + '').padStart(2, 0) + ':'
  var m = (date.getMinutes() + '').padStart(2, 0) + ':'
  var s = (date.getSeconds() + '').padStart(2, 0)
  return Y + M + D + h + m + s
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
